import { createContext, useState, useEffect, useContext } from 'react';
import { getCart, addToCart, updateCartItem, removeCartItem } from '../services/api';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateCart = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      if (!token) {
        setCartItems([]);
        setCartCount(0);
        return;
      }


      const cartData = await getCart();
      const items = cartData?.items || [];
      setCartItems(items);

      // Calculate total quantity across all items
      const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
      setCartCount(totalQuantity);
    } catch (error) {
      console.error('Error updating cart:', error);
      setError('Failed to fetch cart data');
      setCartItems([]);
      setCartCount(0);
    } finally {
      setLoading(false);
    }
  };

  const incrementQuantity = async (productId, currentQuantity) => {
  try {
    await updateCartItem(productId, currentQuantity + 1);
    // Refresh cart data after successful update
    await updateCart();
  } catch (error) {
    console.error("Failed to update cart:", error);
    setError("Failed to update cart");
  }
};

const decrementQuantity = async (productId, currentQuantity) => {
  if (currentQuantity > 1) {
    try {
      await updateCartItem(productId, currentQuantity - 1);
      await updateCart();
    } catch (error) {
      console.error("Failed to update cart:", error);
      setError("Failed to update cart");
    }
  }
};

const handleRemoveItem = async (productId) => {
  try {
    await removeCartItem(productId);
    // Refresh cart after deletion
    await updateCart();
  } catch (error) {
    console.error("Failed to remove item from cart:", error);
    setError("Failed to remove item from cart");
  }
};

  useEffect(() => {
    updateCart();
  }, []);

  return (
    <CartContext.Provider value={{
      cartItems,
      cartCount,
      loading,
      error,
      updateCart,
      incrementQuantity,
      decrementQuantity,
      handleRemoveItem
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);